<template>
  <div id="page" class="container relative" ref="page">
    <div class="px-4 lg:px-8 space-y-4 lg:space-y-6 pt-4 lg:pt-6">
      <PageTitle v-if="title" :back-location="title?.backLocation">
        {{ title.name }}
      </PageTitle>
      <slot />
    </div>
    <div
      v-if="progress && totalProgress < 1"
      class="absolute bg-black/70 top-0 left-0 w-full h-full flex justify-center items-start pt-64"
    >
      <div class="flex items-center gap-4">
        <!-- <IconX v-if="error" :size="20" class="my-auto" /> -->
        <svg viewBox="0 0 20 20" class="w-5 h-5 animate-spin my-auto">
          <circle
            cx="10"
            cy="10"
            r="8"
            stroke="#eee"
            stroke-width="1"
            fill="none"
            class="transition-[stroke-dashoffset]"
            :stroke-dasharray="2 * Math.PI * 8"
            :stroke-dashoffset="2 * Math.PI * 8 * (1 - (totalProgress || 0.75))"
          />
        </svg>
        <p>{{ currentProgressDescription }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementBounding } from "@vueuse/core";
import type { Props as PageTitleProps } from "./PageTitle.vue";

const props = defineProps<{
  title?: PageTitleProps & {
    name: string;
  };
  relative?: boolean;
  progress?: UseProgressReturn<any>;
}>();

const page = ref<HTMLDivElement>();

const bounding = useElementBounding(page);
provide("currentPageBounding", bounding);

const totalProgress = computed(() => {
  if (!props.progress) return 1;
  return props.progress.totalProgress.value;
});

const currentProgressDescription = computed(() => {
  if (!props.progress) return "";
  return props.progress.currentState.value.description ?? "";
});
</script>
